/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Hero_DescriptionInputs */

const en_downloads_hero_description = /** @type {(inputs: Downloads_Hero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get started with the Listening App today by downloading it now. Alternatively, if you're accessing through a browser, the web version of Listening is also available for your convenience.`)
};

const es_downloads_hero_description = /** @type {(inputs: Downloads_Hero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comienza con la app Listening hoy descargándola ahora. Alternativamente, si accedes desde un navegador, la versión web de Listening también está disponible para tu comodidad.`)
};

/**
* | output |
* | --- |
* | "Get started with the Listening App today by downloading it now. Alternatively, if you're accessing through a browser, the web version of Listening is also av..." |
*
* @param {Downloads_Hero_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_hero_description = /** @type {((inputs?: Downloads_Hero_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Hero_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_hero_description(inputs)
	return en_downloads_hero_description(inputs)
});